# On global media query definition
#
# Allow other classes to use media query information
#
# Must match media queries set in CSS:
# src/assets/stylesheets/0.settings/media-queries.scss

window.On = window.On || {}

On.MediaQueries =
  width:
    tiny: 350
    small: 450
    medium: 600
    large: 800
    larger: 950
    full: 1150

  height:
    tiny: 300
    small: 400
    medium: 600
    large: 800
    larger: 900
    full: 1000



// WEBPACK FOOTER //
// ./src/assets/javascripts/settings/media-queries.coffee